<template>
	<div>
		<el-card class="box-card">
			<div class="card-header">
				<el-form :label-width="120">
					<el-form-item :label="$t('device.mqtt_imei')" prop="imei">
						<el-input v-model="imei" :placeholder="$t('device.mqtt_imei')" clearable style="width:300px"></el-input>
					</el-form-item>
					<el-form-item :label="$t('device.mqtt_topic')" prop="topic">
						<el-input v-model="topic" :placeholder="$t('device.mqtt_topic')" clearable style="width:300px"></el-input>
					</el-form-item>
					<el-form-item :label="$t('device.mqtt_data')" prop="data">
						<el-input v-model="data" type="textarea" :rows="5" :placeholder="$t('device.mqtt_data')" style="width:500px"></el-input>
					</el-form-item>
					<el-form-item :label="$t('device.mqtt_version')" prop="v">
						<el-select v-model="v" style="width:80px;flex:0 0 80px">
							<el-option label="3" :value="3"></el-option>
							<el-option label="5" :value="5"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button @click="handleSubmit" type="primary" :loading="loading">{{ $t('device.mqtt_send_btn') }}</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-card>
	</div>
</template>

<script>
	import device from "../../model/device";

	export default {
		name: "mqttSend",
		data() {
			return {
				imei: '',
				topic: '',
				data: '',
				v: 3,
				loading: false
			}
		},
		methods: {
			async handleSubmit() {
				if (!this.imei) {
					this.$message.warning(this.$t('device.mqtt_imei_empty'));
					return;
				}
				if (!this.topic) {
					this.$message.warning(this.$t('device.mqtt_topic_empty'));
					return;
				}
				if (!this.data) {
					this.$message.warning(this.$t('device.mqtt_data_empty'));
					return;
				}

				this.loading = true;
				const ret = await device.mqttSend({
					imei: this.imei,
					topic: this.topic,
					data: this.data,
					v: this.v
				});
				this.loading = false;

				if (ret.code === 200) {
					this.$message.success(this.$t('device.mqtt_send_success'));
				} else {
					this.$message.error(ret.message || this.$t('device.mqtt_send_failed'));
				}
			}
		}
	};
</script>

<style scoped>
	.card-header .el-form-item__content {
		display: flex !important;
	}

	.card-header .el-form-item__label {
		float: left;
	}

	.version-select {
		width: 80px !important;
		flex: 0 0 80px !important;
		max-width: 80px;
	}
</style>
